import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { toHttpParams } from '../project/helpers/to-http-params';
import { ConversationNodeQuery, ConversationNodesSummaryGraph } from './types';

const BASE_URL = `${environment.analytics.url}/analytics/conversation-nodes-summary`;

@Injectable()
export class ConversationNodeService {
  constructor(private http: HttpClient) {}

  load(query: Partial<ConversationNodeQuery>) {
    const params = toHttpParams(query);

    return this.http.get<ConversationNodesSummaryGraph>(BASE_URL, { params });
  }
}
